<app-header *ngIf="showHeader"></app-header>
<app-sidebar *ngIf="sideNavigation"></app-sidebar>
<div
  class="main-container"
  [ngClass]="{ 'class-in-progress': !isToggleSidebar }"
>
  <router-outlet></router-outlet>
</div>
